import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    data: [],
    count: 0,
};
const removeDuplicates = (data, key) => {
    return [...new Map(data.map((x) => [key(x), x])).values()];
};
const { actions, reducer } = createSlice({
    name: 'reduxFlags',
    initialState,
    reducers: {
        setAllFlags: (state, { payload }) => {
            const t = [...state.data, ...payload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
        addFlagFromWS: (state, { payload }) => {
            const updatedPayload = Object.assign(Object.assign({}, payload), { id: payload.uuid });
            delete updatedPayload.uuid;
            const t = [...state.data, updatedPayload];
            const newData = removeDuplicates(t, (it) => it.id);
            state.data = newData;
        },
    },
});
export const { setAllFlags, addFlagFromWS } = actions;
export default reducer;
